export default function regexp(value, { regexp, locale = {} }) {
  /**
   * @description accept a prop of `regexp` to test the value
   * @prop {RegExp} regexp - Regular expression to test the input value
   * @return { string | Component | null } error message, or `null` if the value is passing.
   * */
  return regexp.test(value) ? null : locale.regexp || 'Must pass regular expression';
}
